import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RacingThemeListingCard from '../RacingThemeListingCard/RacingThemeListingCard';
import css from './RacingThemeListingMoreFrom.module.css';

/**
 * More-from-seller listing carousel / grid.
 */
const RacingThemeListingMoreFrom = props => {
  const {
    title,
    viewAllLabel,
    viewAllHref,
    listings,
    className,
    cardVariant = 'grid',
    isFavoriteFn = null,
    onToggleFavorite = null,
  } = props;

  if (!listings?.length) {
    return null;
  }

  return (
    <section className={classNames(css.root, className)} aria-label={title}>
      <div className={css.header}>
        <h2 className={css.title}>{title}</h2>
        {viewAllHref ? (
          <a className={css.viewAll} href={viewAllHref}>
            {viewAllLabel}
          </a>
        ) : null}
      </div>
      <div className={css.track}>
        {listings.map(listing => {
          const { id, ...cardProps } = listing;
          return (
            <div key={id} className={css.cardWrap}>
              <RacingThemeListingCard
                {...cardProps}
                variant={cardVariant}
                favoriteType="listing"
                favoriteId={id}
                isFavorite={typeof isFavoriteFn === 'function' ? !!isFavoriteFn(id) : false}
                onToggleFavorite={onToggleFavorite}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

RacingThemeListingMoreFrom.defaultProps = {
  className: null,
  viewAllLabel: 'View all listings',
  viewAllHref: null,
  listings: [],
  cardVariant: 'grid',
  isFavoriteFn: null,
  onToggleFavorite: null,
};

RacingThemeListingMoreFrom.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  viewAllLabel: PropTypes.string,
  viewAllHref: PropTypes.string,
  cardVariant: PropTypes.string,
  listings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
  isFavoriteFn: PropTypes.func,
  onToggleFavorite: PropTypes.func,
};

export default RacingThemeListingMoreFrom;
